import React from "react";
import { isPricingRedesignEnabled } from "../../../../../featureToggles";
import { ByPeriodLegacy } from "./ByPeriodLegacy";
import { ByPeriodModern } from "./ByPeriodModern";

export const ByPeriod = (props) => {
    if (isPricingRedesignEnabled) {
        return <ByPeriodModern {...props} />;
    }

    return <ByPeriodLegacy {...props} />;
};
